// extracted by mini-css-extract-plugin
module.exports = {"container":"StoreInvitesList_container__nRnXa"};